module.exports = __webpack_public_path__ + "img/dmc.0e6d3ea8.svg";